import { Label, Menu } from 'semantic-ui-react';
import S from '../core.js';

/* Left-hand menu: one entry per account manager, with that manager's reports listed underneath.
 * Clicking the manager's name opens their Reports screen; clicking a report opens the report. */
export default function AccountManagerList({ groups, activeManager, currentKey, onSelectManager, onSelectReport }) {
  return (
    <Menu as="nav" vertical fluid aria-labelledby="managers-heading" className="reportlist managers">
      <Menu.Item header as="h2" id="managers-heading">Account Managers</Menu.Item>
      {groups.map(({ name, reports }) => {
        const active = activeManager === name;
        return (
          <Menu.Item key={name} as="div" className="am" active={active}>
            <button type="button" className="amname" aria-current={active ? 'true' : undefined} onClick={() => onSelectManager(name)}>
              <strong>{name}</strong>
              <Label size="mini" circular aria-label={`${reports.length} report${reports.length === 1 ? '' : 's'}`}>{reports.length}</Label>
            </button>
            {reports.length === 0
              ? <p className="hint amempty">No reports</p>
              : (
                <Menu.Menu className="amreports">
                  {reports.map((r) => {
                    const k = `${r.settlement_report_id}/${r.report_year}/${r.as_at_date}`;
                    const current = k === currentKey;
                    return (
                      <Menu.Item key={k} as="button" type="button" active={current} aria-current={current ? 'true' : undefined} onClick={() => onSelectReport(r)}>
                        <strong>{r.settlement_report_id}</strong>
                        <span className="sub">{r.client_name || 'No client name'}</span>
                        <small className="sub">
                          {r.report_year} · as at <time dateTime={r.as_at_date}>{S.dmy(r.as_at_date)}</time>
                        </small>
                      </Menu.Item>
                    );
                  })}
                </Menu.Menu>
              )}
          </Menu.Item>
        );
      })}
    </Menu>
  );
}
